// Options for the "New Quote" form (Routing / Container & Commodity Details).

export const CONTAINER_GROUPS = [
  {
    label: 'General Purpose',
    options: [
      "20' General Purpose",
      "40' General Purpose",
      "40' General Purpose High Cube",
    ],
  },
  {
    label: 'Operating Reefer',
    options: [
      "20' Operating Reefer",
      "40' Operating Reefer",
    ],
  },
  {
    label: 'Non-Operating Reefer',
    options: [
      "40' Non-Operating Reefer (Dangerous Goods not available)",
    ],
  },
  {
    label: 'Open Top',
    options: [
      "20' Open Top (in-gauge) (Dangerous Goods not available)",
      "40' Open Top (in-gauge) (Dangerous Goods not available)",
      "20' High Cube Open Top (in-gauge) (Dangerous Goods not available)",
      "40' High Cube Open Top (in-gauge) (Dangerous Goods not available)",
    ],
  },
  {
    label: 'Flatrack',
    options: [
      "20' Flatrack (in-gauge) (Dangerous Goods not available)",
      "40' Flatrack (in-gauge) (Dangerous Goods not available)",
      "40' High Cube Flatrack (in-gauge) (Dangerous Goods not available)",
    ],
  },
  {
    label: 'Hard Top',
    options: [
      "40' High Cube Hard Top (in-gauge) (Dangerous Goods not available)",
    ],
  },
  {
    label: 'Tank',
    socOnly: true,
    options: [
      "20' Tank (Available only with SOC)",
    ],
  },
];

export const COMMODITIES = [
  'FAK - Freight all Kind',
  'Textiles & Garments',
  'Chemicals (non-hazardous)',
  'Machinery & Spare Parts',
  'Electronics',
  'Agricultural Products',
  'Food & Beverages',
  'Pharmaceuticals',
  'Furniture',
  'Plastics & Polymers',
  'Ceramics & Tiles',
  'Metals & Scrap',
  'Project / ODC Cargo',
];

export const IMO_CLASSES = [
  {
    label: '1. EXPLOSIVES',
    options: [
      { value: '1', label: '1. Explosives (Not Available)', disabled: true },
    ],
  },
  {
    label: '2. GASES',
    options: [
      { value: '2.1', label: '2.1 Flammable gases' },
      { value: '2.2', label: '2.2 Non-flammable, non-toxic gases' },
      { value: '2.3', label: '2.3 Toxic gases' },
    ],
  },
  {
    label: '3. FLAMMABLE LIQUIDS',
    options: [
      { value: '3', label: '3. Flammable Liquids' },
    ],
  },
  {
    label: '4. FLAMMABLE SOLIDS OR SUBSTANCES',
    options: [
      { value: '4.1', label: '4.1 Flammable solids, self-reactive substances and solid desensitized explosives' },
      { value: '4.2', label: '4.2 Substances liable to spontaneous combustion' },
      { value: '4.3', label: '4.3 Substances which, in contact with water, emit flammable gases' },
    ],
  },
  {
    label: '5. OXIDIZING AGENTS AND ORGANIC PEROXIDES',
    options: [
      { value: '5.1', label: '5.1 Oxidizing substances' },
      { value: '5.2', label: '5.2 Organic peroxides' },
    ],
  },
  {
    label: '6. TOXIC AND INFECTIOUS SUBSTANCES',
    options: [
      { value: '6.1', label: '6.1 Poison' },
      { value: '6.2', label: '6.2 Biohazard (Not Available)', disabled: true },
    ],
  },
  {
    label: '7. RADIOACTIVE SUBSTANCES',
    options: [
      { value: '7', label: '7. Radioactive Substances (Not Available)', disabled: true },
    ],
  },
  {
    label: '8. CORROSIVE SUBSTANCES',
    options: [
      { value: '8', label: '8. Corrosive Substances' },
    ],
  },
  {
    label: '9. MISCELLANEOUS',
    options: [
      { value: '9', label: '9. Miscellaneous Dangerous Substances and Articles' },
    ],
  },
];

export const QUOTE_SIDEBAR_ITEMS = [
  { id: 'new', label: 'New Quote' },
  { id: 'my', label: 'My Quotes' },
  { id: 'special', label: 'Special Cargo Quotes' },
  { id: 'tariffs', label: 'Tariffs' },
  { id: 'detention', label: 'Detention and Demurrage Tariffs' },
  { id: 'exchange', label: 'Rate of Exchange Information' },
  { id: 'loa', label: 'Letter of Authority (FMC)' },
];

export const RECENT_QUOTES_STORAGE_KEY = 'vedyah_recent_quotes';
